export const coreColumnsPrefix = 'coreColumn';
